module.exports = __webpack_public_path__ + "static/media/postgresql.ec03a118.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/postgresql.jpg
// module id = 161
// module chunks = 0